'use client'

import { localizeListQueryParam } from 'src/_helpers/listQueryParams'

/**
 * Ścieżki dla przełącznika języka budowane są na serwerze, więc nie znają query z bieżącego adresu.
 * Bez tego zmiana języka gubi stan listy trzymany w adresie (np. `?zakladka=archiwalne`).
 * Parametry z bieżącego adresu przenosimy na docelową ścieżkę, lokalizując stan listy
 * (np. `strona=3` -> `page=3`), ale nie nadpisujemy tych ustawionych przez przełącznik (np. `token`).
 */
export const withCurrentSearchParams = (path, targetLocale = null) => {
  if (typeof window === 'undefined' || typeof path !== 'string' || !path) return path

  const currentParams = new URLSearchParams(window.location.search)

  if (Array.from(currentParams).length === 0) return path

  const [targetPath, targetQuery = ''] = path.split('?')
  const params = new URLSearchParams(targetQuery)
  // Parametry z przełącznika zapamiętujemy przed kopiowaniem, żeby powtórzone parametry z adresu
  // (np. `dziedzina=16&dziedzina=17`) przeszły w całości, a nie tylko pierwsza wartość.
  const targetParamNames = new Set(params.keys())

  currentParams.forEach((value, key) => {
    const localizedParam = localizeListQueryParam(key, value, targetLocale)

    if (!targetParamNames.has(localizedParam.name)) params.append(localizedParam.name, localizedParam.value)
  })

  const query = params.toString()

  return query ? `${targetPath}?${query}` : targetPath
}
